module.exports = __webpack_public_path__ + "images/root/mainVisual_bgImage_top_sp_657cebb450e7c06e757537186baf1dc6.gif";